import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  styled
} from '@mui/material';

interface PostcardSummary {
  summary: string;
  value: string;
}

interface PostcardSummaryTableProps {
  data: PostcardSummary[];
  direction: string;
}

// Styled components
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  borderRadius: '6px',
  border: '1px solid #E1E8ED',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
  overflow: 'auto',
  maxWidth: '400px',
}));

const StyledTable = styled(Table)({
  minWidth: 350,
});

const HeaderCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: '#E7EFF5',
  color: '#063142',
  fontWeight: 600,
  fontSize: '12px',
  padding: '8px 12px',
  border: '1px solid #D0DCE7',
  textAlign: 'center',
}));

const DataCell = styled(TableCell)<{ direction?: string }>(({ theme, direction }) => ({
  fontSize: '12px',
  padding: '6px 12px',
  border: '1px solid #E1E8ED',
  textAlign: 'center',
  backgroundColor: direction === 'Inbound' ? 'rgb(230, 245, 230)' : 'rgb(255, 240, 240)',
}));

const SummaryLabelCell = styled(DataCell)({
  textAlign: 'left',
  fontWeight: 500,
});

const SummaryValueCell = styled(DataCell)({
  fontWeight: 600,
  textAlign: 'right',
});

function PostcardSummaryTable({ data, direction }: PostcardSummaryTableProps) {
  return (
    <StyledTableContainer>
      <StyledTable>
        <TableHead>
          <TableRow>
            <HeaderCell style={{ minWidth: '200px' }}>
              Summary
            </HeaderCell>
            <HeaderCell style={{ minWidth: '120px' }}>
              
            </HeaderCell>
          </TableRow>
        </TableHead>
        
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              <SummaryLabelCell direction={direction}>
                {row.summary}
              </SummaryLabelCell>
              <SummaryValueCell direction={direction}>
                {row.value}
              </SummaryValueCell>
            </TableRow>
          ))}
        </TableBody>
      </StyledTable>
    </StyledTableContainer>
  );
}

export default PostcardSummaryTable;
